import { lazy } from "react";

export const Navbar = lazy(() => import("./Navbar"));
export const Footer = lazy(() => import("./Footer"));
export const Map = lazy(() => import("./Map"));
export const Socials = lazy(() => import("./Socials"))
export const CallButton = lazy(() => import("./CallButton"))
